export default {
  uploadWrapper: {
    border: "2px dashed #C5C4C4",
    padding: "8px 8px 0px 8px",
    borderRadius: "5px"
  },
  center: {
    textAlign: "center"
  },
  title: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 600
  },
  active: {
    backgroundColor: '#24b7cc',
    padding: "8px 8px 0px 8px",
    height: "100%",
    borderRadius: "5px"
  },
}